/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseverifyyouremailtocontinue5Inputs */

const en_pleaseverifyyouremailtocontinue5 = /** @type {(inputs: Pleaseverifyyouremailtocontinue5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please verify your email to continue.`)
};

const de_pleaseverifyyouremailtocontinue5 = /** @type {(inputs: Pleaseverifyyouremailtocontinue5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätige deine E-Mail-Adresse, um weiterzumachen.`)
};

/**
* | output |
* | --- |
* | "Please verify your email to continue." |
*
* @param {Pleaseverifyyouremailtocontinue5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseverifyyouremailtocontinue5 = /** @type {((inputs?: Pleaseverifyyouremailtocontinue5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseverifyyouremailtocontinue5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseverifyyouremailtocontinue5(inputs)
	return de_pleaseverifyyouremailtocontinue5(inputs)
});
export { pleaseverifyyouremailtocontinue5 as "pleaseVerifyYourEmailToContinue" }